import { createContext } from 'react'

import { type Transcript } from 'modules/meetings/lib/utils/transcriptUtils'

export interface MeetingTranscriptContextState {
  transcript: Transcript | null
  loadingTranscript: boolean
  refetchTranscript: () => Promise<void>
  transcriptExpirationTime: number | null
}

export const MeetingTranscriptContext = createContext<MeetingTranscriptContextState | undefined>(
  undefined
)
